import { C } from '../../theme/palette';

export const StatBox = ({ label, value, color = C.navy, icon, sous }) => (
  <div
    style={{
      background: color + '10',
      border: '1px solid ' + color + '20',
      borderRadius: 10,
      padding: '10px',
      textAlign: 'center',
    }}
  >
    {icon && <div style={{ fontSize: 15, marginBottom: 3 }}>{icon}</div>}
    <div style={{ fontSize: 7.5, color, fontWeight: 600, marginBottom: 2, lineHeight: 1.3 }}>
      {label}
    </div>
    <div style={{ fontSize: 11, fontWeight: 900, color }}>{value}</div>
    {sous && (
      <div style={{ fontSize: 8, fontWeight: 700, color: C.grey, marginTop: 2 }}>{sous}</div>
    )}
  </div>
);
